import { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { apiurl } from '../common/constants';
import { useAuthAxios } from '../components/authfetch';

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
    // UI States
    const [openOrderForm,setOpenOrderForm] = useState(false);
    const [alert, setAlert] = useState(false);
    const [toast,setToast] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [currentSelectedProduct,setCurrentSelectedProduct] = useState(null);
    const [brands,setBrands] = useState(null);
    const [categories, setCategories]  = useState(null);
    const [productRefresh,setProductRefresh] = useState(0);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrderingEnabled, setIsOrderingEnabled] = useState(true);
    
    // Auth Axios instance
    const authAxios = useAuthAxios();

    // Business/Music Store States
    

    // Helper function
    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert(null), 3000);
    };

    const selectProductForEdit = (product) => {
        setCurrentSelectedProduct(product);
    }

    const fetchBrands = async () => {
        try {
            const { data } = await authAxios.get(apiurl + "/brands");
            setBrands(data.data);
        } catch (error) {
            console.error("Failed to fetch brands", error);
        }
    }

    const fetchCategories = async () => {
        try {
            const { data } = await authAxios.get(apiurl + "/categories");
            setCategories(data.data);
        } catch (error) {
            console.error("Failed to fetch categories", error);
        }
    }

    const fetchOrderingStatus = async () => {
        try {
            const { data } = await authAxios.get(apiurl + "/settings/ordering_enabled");
            if (data.statusCode === 200) {
                setIsOrderingEnabled(data.data.value);
            }
        } catch (error) {
            console.error("Failed to fetch ordering status:", error);
        }
    }

    useEffect(() => {
        fetchOrderingStatus();
        if (!brands) {
            fetchBrands();
        }
         if (!categories) {
            fetchCategories();
        }
    }, [productRefresh]);



    // Important: useMemo prevents App.js from re-rendering everything on every click
    const value = useMemo(() => ({
       openOrderForm,setOpenOrderForm,
       alert, showAlert,
       toast,setToast,
       isLoading,setIsLoading,
       currentSelectedProduct,setCurrentSelectedProduct,
       selectProductForEdit,
       brands,setBrands,
       categories,setCategories,
       productRefresh,setProductRefresh,
       isAdmin,setIsAdmin,
       isOrderingEnabled, setIsOrderingEnabled, fetchOrderingStatus
    }), [openOrderForm, alert, toast,isLoading,currentSelectedProduct,brands,categories,productRefresh,isAdmin, isOrderingEnabled]);

    return (
        <StoreContext.Provider value={value}>
            {children}
        </StoreContext.Provider>
    );
};

export const useStore = () => {
    const context = useContext(StoreContext);
    if (!context) throw new Error("useStore must be used within StoreProvider");
    return context;
};